import { RobotActions } from '../utils/constants';

export const DRIVING_DISABLED_WARNING_REASON = {
  CHARGING: 'charging',
  WIRED_CONTROLLER: 'wiredController',
  WIRED_DRIVE_BASE: 'wiredDriveBase',
} as const;

export type DrivingDisabledWarningReason = (typeof DRIVING_DISABLED_WARNING_REASON)[keyof typeof DRIVING_DISABLED_WARNING_REASON];

interface DrivebaseSystemStateForDrivingWarning {
  controllerConnected?: unknown;
  controllerConnection?: unknown;
  drivebaseCharging?: unknown;
}

export function resolveDrivingDisabledWarningReason(
  systemState: DrivebaseSystemStateForDrivingWarning | null | undefined,
  bpsConnectionType: string | null | undefined
): DrivingDisabledWarningReason | null {
  if (!systemState) {
    return null;
  }

  if (systemState.controllerConnected === true && systemState.controllerConnection === 'usb_connection') {
    return DRIVING_DISABLED_WARNING_REASON.WIRED_CONTROLLER;
  }

  if (bpsConnectionType === RobotActions.STATE.CONNECTION_TYPE.SERIAL) {
    return DRIVING_DISABLED_WARNING_REASON.WIRED_DRIVE_BASE;
  }

  if (systemState.drivebaseCharging === true) {
    return DRIVING_DISABLED_WARNING_REASON.CHARGING;
  }

  return null;
}
